import { rem } from "polished";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled, { css } from "styled-components";
import {
  changeThickness,
  getThickness,
} from "../../../../../../lib/redux/slices/dimensions-slice";
import { useUpdateCart } from "../../../../../../hooks/use-update-cart";

const Thickness = ({ data }) => {
  const dispatch = useDispatch();
  const selectedThickness = useSelector(getThickness);
  const { updateCart } = useUpdateCart();

  const setThickness = (data) => {
    dispatch(changeThickness(data));
    updateCart((storeData) => ({
      ...storeData,
      dimensions: {
        ...storeData.dimensions,
        thickness: data,
      },
    }));
  };

  if (!data) return void 0;

  return (
    <Layout className="builder-element">
      <div className="element">
        {/* <h5>Thickness</h5> */}
        <h5>Tjocklek</h5>
        <div className="thickness options-list">
          {data.map((item, i) => {
            return (
              <label className="radioFields options" key={i} data-selected={selectedThickness === item.thickness}>
                  <input
                    type="radio"
                    value={item.thickness}
                    name="thickness"
                    checked={selectedThickness === item.thickness}
                    onChange={(e) => setThickness(e.target.value)}
                    hidden
                  />
                  {/* <span className="checkbox" /> */}
                  {item.thickness}
              </label>
            );
          })}
        </div>
      </div>
    </Layout>
  );
};
export default Thickness;

const Layout = styled.div`
  ${({ theme }) => css`
    .element {
      h5 {
        margin-bottom: ${rem(15)};
        font-size: 14px;
        font-weight: bold;
      }

        .options-list{
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 15px;

          .options{
            padding: 20px 10px;
            border-radius: 30px;
            background-color:  ${theme.colors.white};
            text-align: center;
            color: ${theme.colors.black};
            transition: 0.3s ease all;
            cursor: pointer;

            &[data-selected="true"] {
              background-color:${theme.colors.primary};
              color: ${theme.colors.white}
            }

          }
        }

      .radioField {
        input {
          display: none;
          &:checked {
            + .checkbox {
              background-color: ${theme.colors.primary};
              border-color: ${theme.colors.primary};
            }
          }
        }

       .label {
          display: flex;
          align-items: center;

           .options{
              padding: 10px;
              border-radius: 30px;
              background-color:  ${theme.colors.white};
              text-align: center;
              color: ${theme.colors.black};
              transition: 0.3s ease all;

              &[data-selected="true"] {
                background-color:${theme.colors.primary};
                color: ${theme.colors.white}
              }

            }

          .checkbox {
            width: 100%;
            height: 20px;
            border: 1px solid ${theme.colors.gray["300"]};
            background-color: transparent;
            transition: 0.3s ease all;
            display: inline-block;
            flex: 0 0 35px;
            max-width: 35px;
            margin-right: ${rem(15)};
          }
        }

        + .radioField {
          margin-top: ${rem(15)};
        }
      }
    }
  `}
`;
